export default __webpack_public_path__ + "static/media/galleryimg4.6e5a37f0.jpg";